export default "__VITE_ASSET__Cv24AYdx__"